'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _spauiUtils = require('@tencent/spaui-utils');

/**
 * Collapse 接口参数
 * @property {titleline} 全局属性
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {titleline} 基础属性
 * @property {bool} open=false 是否展开
 * @property {bool} [transitionAppear=true] 是否需要动画
 * @property {func} [onTransitionEnd] 动画结束回调<br />onTransitionEnd(dom)
 * @example
 * children 只能是一个元素
 */
exports.default = {
    open: {
        type: _spauiUtils.PropTypes.bool.isRequired,
        defaultValue: false
    },
    transitionAppear: {
        type: _spauiUtils.PropTypes.bool,
        defaultValue: true
    },
    onTransitionEnd: {
        type: _spauiUtils.PropTypes.func
    }
}; /**
    * @fileoverview 组件参数配置
    */